import { useState, useEffect, Fragment } from "react";
import Answers from "./Answers";
import ActionButton from "../Common/ActionButton";
import StatusBar from "./StatusBar";
import Popup from "../Common/Popup";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
// api
import { Signle_Call } from "../Api/Api";
// functions
import { ExamTimeTypes, ExamTime } from "../../Functions";

const Exam = (props) => {
  const [state, setState] = useState({
    exam_id: null,
    exam_time: 0,
    questions: [],
    activeQuestion: 0,
    lockMode: false,
    errorPopup: { active: 0, text: "خطایی در سرور وجود دارد", status: null },
  });
  const [textAnwsers, setTextAnwsers] = useState([]);
  const [textAnwser, setTextAnwser] = useState({
    question_id: 0,
    answer_text: "",
  });
  const [examDetail, setExamDetail] = useState();
  const [count, setCount] = useState(0);
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleTextAnw = (answer_text) => {
    setTextAnwser({
      question_id: state.questions[state.activeQuestion].id,
      answer_text,
    });
  };

  const handleAddTextToOthers = () => {
    if (textAnwser.question_id !== 0 && textAnwser.answer_text !== "") {
      const state = [...textAnwsers];
      state.push(textAnwser);
      setTextAnwsers(state);
    }
  };

  const [textAlert, setTextAlert] = useState({
    text: "گزینه مورد نظر را انتخاب کنید!",
    icon: "icon-exclamation-mark",
    color: "#ff1300",
    active: false,
  });
  useEffect(() => {
    const data = localStorage.getItem("lastExam");
    const lastExam = JSON.parse(data);
    props.location.state &&
      setState({
        ...state,
        exam_id: props.location.state.exam_id,
        // exam_time: parseInt(localStorage.getItem('examTimeLeft') || props.location.state.exam_time),
        exam_time: ExamTime(
          ExamTimeTypes.decrypt,
          localStorage.getItem("examTimeLeft")
        ),
        questions: props.location.state.questions,
      });
    lastExam && setExamDetail(lastExam);
  }, []);
  const handle_getExamResults = async () => {
    let finalAnswers = [];
    const questions = [...state.questions];
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].answers.length) {
        const tempAnw = questions[i].answers.filter(
          (anw) => anw.active === true
        );
        finalAnswers.push({
          question_id: questions[i].id,
          answer_ids: tempAnw.map((anw) => anw.id),
        });
      }
    }
    textAnwsers.map((t) => {
      finalAnswers.push({
        question_id: t.question_id,
        answer_text: t.answer_text,
      });
    });

    const apiCall = () => {
      const DATA = {
        exam_id: state.exam_id,
        answers: finalAnswers,
      };
      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };
      return new Promise((result) => {
        result(
          apiCall({
            method: "post",
            data: DATA,
            path: `exam_result`,
          })
        );
      });
    };
    const examResults_result = await apiCall();
    if (examResults_result.type) {
      examResults_result.response.data.exam_id = state.exam_id;
    }
    return examResults_result;
  };

  const handleSelect = (id) => {
    let newAnswers = [...state.questions[state.activeQuestion].answers];
    let question = state.questions[state.activeQuestion];
    for (let i = 0; i < newAnswers.length; i++) {
      if (
        newAnswers[i].id === id &&
        question.right_answers !== count &&
        newAnswers[i].active !== true
      ) {
        setCount(count + 1);
        newAnswers[i].active = true;
        // ------ setTextAlert ------
        setTextAlert({ ...textAlert, active: false });
      } else if (newAnswers[i].active === true && newAnswers[i].id === id) {
        newAnswers[i].active = false;
        setCount(count - 1);
      }
    }
    let newQuestions = [...state.questions];
    newQuestions[state.activeQuestion].answers = newAnswers;
    setState({ ...state, questions: newQuestions });
  };

  const enable_lockMode = async (set_timeLeftIsZero) => {
    set_timeLeftIsZero && setState({ ...state, lockMode: true });
    const examResults_results = await handle_getExamResults();
    if (examResults_results.type) {
      setTimeout(
        () => {
          const examResults_location = {
            pathname: "/examResults",
            state: examResults_results.type
              ? examResults_results.response.data
              : undefined,
          };
          props.history.replace(examResults_location);
        },
        set_timeLeftIsZero ? 3000 : 0
      );
    } else {
      localStorage.removeItem("examTimeLeft");
      setState({
        ...state,
        exam_time: null,
        errorPopup: {
          ...state.errorPopup,
          active: 1,
          text:
            examResults_results.response.data.message ||
            "خطایی در سرور وجود دارد",
          status: examResults_results.response.status,
        },
      });
    }
  };

  const handleNextPage = (isThis_lastQuestion) => {
    let newAnswers = [...state.questions[state.activeQuestion].answers];
    if (textAnwser.question_id !== 0 && textAnwser.answer_text !== "") {
      handleAddTextToOthers();
      setTextAnwser({ question_id: 0, answer_text: "" });
    }
    let is_answerSelected = false;
    for (let i = 0; i < newAnswers.length; i++) {
      is_answerSelected = true;
      setCount(0);
    }
    const targetQuestion = state.activeQuestion + 1;
    if (is_answerSelected || textAnwsers.length) {
      !isThis_lastQuestion &&
        setState({ ...state, activeQuestion: targetQuestion });
      if (isThis_lastQuestion) {
        enable_lockMode(false);
        setButtonLoader(true);
      }
    }

    !is_answerSelected && setTextAlert({ ...textAlert, active: false });
  };

  const handlePrevPage = () => {
    const targetQuestion = state.activeQuestion - 1;
    setState({ ...state, activeQuestion: targetQuestion });
    setTextAlert({ ...textAlert, active: false });
  };

  // window.onbeforeunload = (event) => {
  // 	const e = event || window.event;
  // 	e.preventDefault();
  // 	if (e) {
  // 		e.returnValue = '';
  // 	}
  // 	return '';
  // };
  return (
    <Fragment>
      <div className="ExamPage col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="exam-container contain col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="exam">
            <div className="exam-img">
              <img
                alt="img-exam"
                src={
                  examDetail?.pic ? examDetail?.pic : "/img/archive-book.png"
                }
              />
            </div>
            <span className="exam-title">{examDetail?.title}</span>
            <div className="exam-detail info">
              <span>
                {examDetail?.is_exam_active === "active" &&
                examDetail?.start_date === null &&
                examDetail?.stop_date === null
                  ? null
                  : examDetail?.is_exam_active === "inactive" &&
                    examDetail?.start_date &&
                    examDetail?.stop_date !== null
                  ? examDetail?.start_date
                  : examDetail?.is_exam_active === "inactive" &&
                    examDetail?.start_date === null &&
                    examDetail?.stop_date === null
                  ? "وقت این ازمون به اتمام رسیده است"
                  : examDetail?.is_exam_active === "inactive" &&
                    examDetail?.start_date === null &&
                    examDetail?.stop_date !== null
                  ? examDetail?.stop_date
                  : examDetail?.is_exam_active === "inactive" &&
                    examDetail?.start_date !== null &&
                    examDetail?.stop_date === null
                  ? examDetail?.start_date
                  : null}
              </span>

              <button disabled={true}>درحال انجام آزمون</button>
            </div>
          </div>
          <div className="ExamPage_wrapper">
            <StatusBar
              activeQuestion={state.activeQuestion + 1}
              allQuestions={
                state.questions.length !== 0 ? state.questions.length : 0
              }
              exam_time={state.exam_time}
              enable_lockMode={() => enable_lockMode(true)}
            />
            <div className="exam-question">
              {state.questions[state.activeQuestion]?.pic ? (
                <img
                  src={state.questions[state.activeQuestion]?.pic}
                  alt="exam-img"
                />
              ) : null}

              <p className="exam_question">
                {state.questions.length > 0
                  ? `${state.questions[state.activeQuestion].description} `
                  : null}
              </p>

              {state.questions[state.activeQuestion]?.right_answers > 1 ? (
                <span className="exam-cout">(بیش از یک مورد)</span>
              ) : null}
            </div>
            <Answers
              handleTextAnw={handleTextAnw}
              lockMode={buttonLoader ? buttonLoader : state.lockMode}
              answers={
                state.questions.length > 0
                  ? state.questions[state.activeQuestion].answers
                  : []
              }
              handleSelect={(id) => handleSelect(id)}
            />
            {state.questions.length > 0 && (
              <div className="prev_next_buttons col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {state.activeQuestion > 0 && (
                  <ActionButton
                    WhiteMode={true}
                    OnLoadMode={false}
                    DisableMode={state.lockMode || buttonLoader ? true : false}
                    ClassNames={["prevOrNext_option", "prev"]}
                    DisableOnLoadMode={false}
                    Text={"قبلی"}
                    DoAction={() => handlePrevPage()}
                    Type={false}
                  />
                )}
                <ActionButton
                  WhiteMode={false}
                  OnLoadMode={buttonLoader ? true : false}
                  DisableMode={state.lockMode ? true : false}
                  ClassNames={["prevOrNext_option", "next"]}
                  DisableOnLoadMode={state.lockMode ? false : true}
                  Text={
                    state.questions.length === state.activeQuestion + 1
                      ? "ثبت و پایان"
                      : "بعدی"
                  }
                  DoAction={() =>
                    handleNextPage(
                      state.questions.length === state.activeQuestion + 1
                        ? true
                        : false
                    )
                  }
                  Type={false}
                />
              </div>
            )}
            <p
              className={`textAlert Transition_All_5ms${
                state.lockMode || textAlert.active ? " active" : ""
              }`}
              style={{ color: state.lockMode ? "#ff1300" : textAlert.color }}
            >
              <i
                className={
                  state.lockMode ? "icon-exclamation-mark" : textAlert.icon
                }
              />
              {state.lockMode ? "وقت آزمون به پایان رسید" : textAlert.text}
            </p>
          </div>
          <Popup active={state.errorPopup.active} class="box-exam_error">
            <div className="error_box-exam">
              <strong> خطا کد ({state.errorPopup.status})</strong>
              <h4>{state.errorPopup.text}</h4>
              <Button
                variant="contained"
                onClick={() => props.history.push("/")}
              >
                خروج
              </Button>
            </div>
          </Popup>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(Exam);
